export const NO_DELAY = 0;
export const DEFAULT_DROPDOWN_DELAY = 250;
export const HAS_AUDIO_DETECT_DELAY = 200;
export const HIDE_VIEW_FORMATS_DELAY = 2000;
